module.exports = __webpack_public_path__ + "img/time_small.3d959139.svg";